export default __webpack_public_path__ + "static/media/Aneomi-5.67ba3b33.png";